import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "checkbox-input" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "loader"
}
const _hoisted_4 = {
  key: 1,
  class: "iatse-icon-green-tick checkmark"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "body-text",
  for: "recaptcha"
}, "I'm not a robot", -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"recaptcha-wrapper\"><span class=\"iatse-icon-reCAPTCHA\"><span class=\"path1\"></span><span class=\"path2\"></span><span class=\"path3\"></span></span><small class=\"text\">reCAPTCHA</small><small class=\"text\">Privacy-Terms</small></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox recaptcha", _ctx.recaptchaError ? 'error' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        type: "checkbox",
        class: "links recaptcha",
        id: "recaptcha",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRecaptcha && _ctx.handleRecaptcha(...args)), ["prevent"])),
        disabled: _ctx.loadingRecaptcha || _ctx.token
      }, null, 8, _hoisted_2),
      (_ctx.loadingRecaptcha)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (!_ctx.loadingRecaptcha && _ctx.token)
        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
        : _createCommentVNode("", true),
      _hoisted_5
    ]),
    _hoisted_6
  ], 2))
}